"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
function OnEscapeHoC(WrappedComponent) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(OnEscape, _super);
            function OnEscape() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.state = {
                    escapedClicked: false,
                };
                // HACK: SEE ISSUE https://github.com/Microsoft/TypeScript/issues/1224
                _this.escapeClick = function (event) {
                    var ESCAPE_KEY = 27;
                    if (event.keyCode === ESCAPE_KEY) {
                        _this.setState({ escapedClicked: true });
                    }
                };
                return _this;
            }
            OnEscape.prototype.componentDidMount = function () {
                // // If we are in an environment without a DOM such
                // // as shallow rendering or snapshots then we exit
                // // early to prevent any unhandled errors being thrown.
                // if (typeof document === 'undefined' || !document.createElement) {
                //   return;
                // }
                document.addEventListener("keydown", this.escapeClick);
            };
            OnEscape.prototype.componentWillUnmount = function () {
                document.removeEventListener("keydown", this.escapeClick);
            };
            OnEscape.prototype.render = function () {
                return React.createElement(WrappedComponent, __assign({}, this.props, { escapedClicked: this.state.escapedClicked }));
            };
            return OnEscape;
        }(React.Component)),
        _a.displayName = "OnEscape(" + (WrappedComponent.displayName ||
            WrappedComponent.name) + ")",
        _a;
}
exports.default = OnEscapeHoC;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/behaviors/OnEscapeHoC/OnEscapeHoC.js
// module id = 1840
// module chunks = 8